import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { nudgeViewportScrollToWakeIx2, rebindWebflowIx2AfterInjectedHtml, scheduleIx2ScrollNudgesAfterRebind, WF_IX2_HEADER_REVEAL_DELAY_MS } from '../webflow/wf-page-html.util';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: [ './home.component.css' ]
})
export class HomeComponent implements OnInit, AfterViewInit {

  /** Micro-scroll extra: el halo `.border-light-effect` a veces no arranca hasta un segundo disparo tras `ix2.init`. */
  private static readonly IX2_HALO_EXTRA_NUDGE_MS = 120;

  private readonly title = inject( Title );

  private readonly meta = inject( Meta );

  ngOnInit(): void {

    this.title.setTitle( 'iCortex — Smart growth for your ecosystem' );
    this.meta.updateTag( {
      name: 'description',
      content: 'Predictive Cortex™, Lifestyle Engine™ and omnichannel orchestration for modern e-commerce.'
    } );
    this.meta.updateTag( {
      name: 'keywords',
      content: 'iCortex, Predictive Cortex, Lifestyle Engine, Revenue Recovery, e-commerce, AI'
    } );
  }

  /**
   * Tras navegación SPA, `NavigationEnd` puede ejecutar `ix2.init` antes de que el Hero esté en el DOM.
   * Repite rebind + micro-scroll cuando la vista del Home ya está montada (halo `.border-light-effect`).
   */
  ngAfterViewInit(): void {

    this.scheduleWebflowIx2ForHeroShell();
  }

  private scheduleWebflowIx2ForHeroShell(): void {

    window.setTimeout( () => {

      requestAnimationFrame( () => {

        requestAnimationFrame( () => {

          rebindWebflowIx2AfterInjectedHtml();
          scheduleIx2ScrollNudgesAfterRebind( { headerRevealDelayMs: WF_IX2_HEADER_REVEAL_DELAY_MS } );

          window.setTimeout( () => {

            nudgeViewportScrollToWakeIx2();
          }, HomeComponent.IX2_HALO_EXTRA_NUDGE_MS );
        } );
      } );
    }, 0 );
  }

}
